import { render, staticRenderFns } from "./whiteTitleWidge.vue?vue&type=template&id=773c3887&scoped=true"
import script from "./whiteTitleWidge.vue?vue&type=script&lang=js"
export * from "./whiteTitleWidge.vue?vue&type=script&lang=js"
import style0 from "./whiteTitleWidge.vue?vue&type=style&index=0&id=773c3887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c3887",
  null
  
)

export default component.exports